export default __webpack_public_path__ + "static/media/shopItems.20517450.png";